import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IndexedDBService } from "../../services/indexedDbService";

const DB_KEY = "bankUserStore";
const db = new IndexedDBService();

export const userBankStore = create(
  devtools((set, get) => ({
    bankUserStore: null,
    loading: false,

    loadUserBank: async () => {
      const existing = await db.getItemByKey(DB_KEY);
      if (existing?.value) {
        set({ bankUserStore: existing.value });
      }
    },

    saveUserBank: async (partialOrFullDraft) => {
      const current = get().bankUserStore || {};
      const updated = {
        ...current,
        ...partialOrFullDraft,
        updatedAt: new Date().toISOString(),
      };
      set({ bankUserStore: updated });
      try {
        await db.setItemByKey(DB_KEY, updated); // persiste
      } catch (err) {
        console.error("Error guardando bankUserStore en IDB:", err);
      }
    },

    // 🔹 Limpiar bankUserStore
    clearUserBank: async () => {
      await db.deleteItem(DB_KEY);
      set({ bankUserStore: null });
    },
  }))
);
